"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEditor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_styled_components_1 = require("../../../common-styled-components");
const TextInput_1 = require("../../../generic/TextInput");
const useFetch_1 = __importDefault(require("../../../../hooks/useFetch"));
const apiUtils_1 = require("../../../../util/apiUtils");
const react_select_1 = __importDefault(require("react-select"));
const YearContext_1 = require("../../../../contexts/YearContext");
const react_1 = require("react");
const emptyOption = { label: "Select company", value: null };
const UserEditor = ({ state, updateValue, modalType, }) => {
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [overview, _setOverviewUrl, setOverviewBody] = (0, useFetch_1.default)("admin/overview.json", undefined, true);
    (0, react_1.useEffect)(() => {
        setOverviewBody(JSON.stringify({ pool_year: selectedYear }));
    }, [selectedYear, setOverviewBody]);
    if (modalType === "remove") {
        return (0, jsx_runtime_1.jsxs)("div", { children: ["Remove ", state.username, "?"] });
    }
    const companyOptions = [emptyOption].concat(overview.status === apiUtils_1.LoaderStatus.Success
        ? overview.data.companies.map((c) => ({
            label: c.name,
            value: c.id,
        }))
        : []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Name" }), (0, jsx_runtime_1.jsx)(TextInput_1.TextInput, { value: state.name ?? "", onChange: (newValue) => updateValue("name", newValue) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Email" }), (0, jsx_runtime_1.jsx)(TextInput_1.TextInput, { value: state.username ?? "", onChange: (newValue) => updateValue("username", newValue) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Company" }), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: companyOptions, onChange: (newValue) => updateValue("company_id", newValue?.value), value: companyOptions.find((c) => c.value === state.company_id) ??
                            emptyOption, isOptionSelected: (option) => option.value === state.company_id })] })] }));
};
exports.UserEditor = UserEditor;
